





















































































import { Vue, Component } from "vue-property-decorator";
import { Register as IRegister } from "@/interface/login";
import { register, getQrCode } from "@/http/login.api";
import { getAreaData } from "@/utils/index";
@Component
export default class Register extends Vue {
  validateQr(rule: any, value: any, callback: Function) {
    if (!value) {
      return callback("请填写验证码");
    } else {
      callback();
    }
  }
  validatePwd(rule: any, value: any, callback: Function) {
    const len = this.form.password.length;
    if (len > 14 || len < 8) {
      return callback("密码长度在8-14位之间");
    } else {
      callback();
    }
  }
  validateAddress(rule: any, value: any, callback: Function) {
    const len = this.form.hospitalAddress.length;
    if (!len) {
      return callback("医院地址不能为空");
    } else {
      callback();
    }
  }
  checked = false;
  form: IRegister = {
    mobile: "",
    verCode: "",
    password: "",
    username: "",
    hospitalAddress: [],
    hospitalName: "",
    deptName: "",
    deptDirectorName: "",
    deptDirectorMobile: ""
  };
  qrCodeIsSend = false;
  areaData = getAreaData();
  rules = {
    mobile: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
    verCode: [{ validator: this.validateQr, trigger: "blur" }],
    password: [{ validator: this.validatePwd, trigger: "blur" }],
    username: [
      { required: true, message: "真实姓名不能为空", trigger: "blur" }
    ],
    hospitalAddress: [
      { required: true, validator: this.validateAddress, trigger: "blur" }
    ],
    hospitalName: [
      { required: true, message: "医院名称不能为空", trigger: "blur" }
    ],
    deptName: [
      { required: true, message: "科室全称不能为空", trigger: "blur" }
    ],
    deptDirectorName: [
      { required: true, message: "科主任名字不能为空", trigger: "blur" }
    ],
    deptDirectorMobile: [
      { required: true, message: "科主任电话不能为空", trigger: "blur" }
    ]
  };
  get qrName() {
    return this.qrCodeIsSend ? `已发送(${this.time}s)` : "发送验证码";
  }
  async onSubmit() {
    const ref = this.$refs.register as any;
    const res = await ref.validate();
    if (!res) return;
    const data: IRegister<string> = {
      ...this.form,
      hospitalAddress: this.form.hospitalAddress.join(",")
    };
    await register(data);
    await this.$alert("注册成功", "注册", {
      type: "success",
      showClose: false
    });
    this.$router.push("/login");
    // await ref.validate()
  }
  time = 60;
  async handleQrCodeClick() {
    const { mobile } = this.form;
    await getQrCode(mobile);
    this.qrCodeIsSend = true;
    const timer = setInterval(() => {
      this.time -= 1;
      if (this.time === 0) {
        this.qrCodeIsSend = false;
        this.time = 60;
        clearInterval(timer);
      }
    }, 1000);
  }
  mounted() {
    console.log(getAreaData());
  }
}
